import profile from './profile.json';
import experience from './experience.json';
import skills from './skills.json';
import education from './education.json';
import certifications from './certifications.json';
import achievements from './achievements.json';
import testimonials from './testimonials.json';
import consulting from './consulting.json';

export { profile, experience, skills, education, certifications, achievements, testimonials, consulting };
